import moment from 'moment'

import type {BuildId} from '../types'

import stableSort from './stableSort'

type GetDurationParams = {
  startDate?: string | null
  finishDate?: string | null
  runningInfo?: {
    elapsedSeconds?: number | null
  } | null
}
export const getDuration = ({startDate, finishDate, runningInfo}: GetDurationParams) =>
  runningInfo?.elapsedSeconds ?? moment(finishDate).diff(moment(startDate), 'seconds')

type GetTimeInQueueParams = {
  startDate?: string | null
  queuedDate?: string | null
}
export const getTimeInQueue = ({startDate, queuedDate}: GetTimeInQueueParams) =>
  moment(startDate).diff(moment(queuedDate), 'seconds')

type Stat = {
  rawId: number | null
  startDate: string | null
}
export function getStatsAroundBuild<T extends Stat>(
  stats: readonly T[],
  aroundBuild: BuildId,
  statCount: number,
) {
  const sortedStats = stableSort(stats, (a, b) => {
    if (a.startDate == null || b.startDate == null || a.startDate === b.startDate) {
      return 0
    }

    return a.startDate < b.startDate ? 1 : -1
  })

  const wantedBuildIndex = sortedStats.findIndex(stat => stat.rawId === aroundBuild)
  const result = []

  if (sortedStats.length > 0 && wantedBuildIndex !== -1) {
    result.push(sortedStats[wantedBuildIndex])

    for (let i = 1; i < statCount; i++) {
      const previousElement = sortedStats[wantedBuildIndex - i]
      const nextElement = sortedStats[wantedBuildIndex + i]

      if (previousElement != null && result.length < statCount) {
        result.unshift(previousElement)
      }

      if (nextElement != null && result.length < statCount) {
        result.push(nextElement)
      }
    }
  }

  return result
}
